import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from 'app/scripts/components/common/inputs/text-field';

class BroadcastTitle extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      status: 'error',
      title: props.value
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    var oldTitle = this.props.value;
    var newTitle = nextProps.value;
    if (oldTitle !== newTitle) {
      this.setState({ title: newTitle, status: 'success' });
    }
  }
  onTitleChange(title) {
    var empty = !title || !title.trim().length;
    var status = 'none';

    if (empty) {
      status = 'error';
    } else {
      status = 'success';
    }
    this.setState({ title, status });
  }

  getValue() {
    return this.state.title;
  }

  isValid() {
    return this.state.status === 'success';
  }

  render() {
    var { title, status } = this.state;
    var { validate, disabled } = this.props;
    var props = {
      onChange: this.onTitleChange.bind(this),
      description: 'Title',
      value: title,
      maxLength: 45,
      placeholder: 'e.g. Breaking News',
      disabled: disabled,
      showCharCounter: true
    };

    if (validate) {
      props.validation = { status };
    }

    return <TextField {...props} />;
  }
}

BroadcastTitle.propTypes = {
  validate: PropTypes.bool,
  value: PropTypes.string,
  disabled: PropTypes.bool
};

BroadcastTitle.defaultProps = {
  value: ''
};

BroadcastTitle.displayName = 'BroadcastTitle';

export default BroadcastTitle;
